/*
 * page
 */
import { cn } from "@timeprox/react/helpers"
import type { ReactNode } from "react"

export type PageProps = {
	centerHorizontal?: boolean
	centerVertical?: boolean
	scrolling?: boolean
	id?: string
	Component?: any
	className?: string
	children: ReactNode
}

export function Page({
	centerHorizontal = true,
	centerVertical = true,
	scrolling = true,
	id = "page",
	Component = "div",
	className,
	children,
}: PageProps) {
	if (scrolling) {
		return (
			<div className={"flex w-full max-h-full min-h-full overflow-y-auto"}>
				<Component
					id={id}
					className={cn(
						"bg-background text-foreground flex flex-1 w-full h-auto min-h-fit flex-col",
						centerHorizontal ? "items-center" : "",
						centerVertical ? "justify-center" : "",
						className,
					)}
				>
					{children}
				</Component>
			</div>
		)
	}

	return (
		<Component
			id={id}
			className={cn(
				"bg-background text-foreground flex w-full h-full min-h-fit flex-col",
				centerHorizontal ? "items-center" : "",
				centerVertical ? "justify-center" : "",
				className,
			)}
		>
			{children}
		</Component>
	)
}
